import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../images/logo/logo-text.png";
import { toast } from "react-toastify";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import axiosInstance from "../../services/AxiosInstance";
import PasswordInput from "../components/PasswordInput";

const ResetPassword = () => {
  const [formData, setFormData] = useState({
    token: "",
    email: "",
    password: "",
    password_confirmation: "",
  });

  const navigate = useNavigate();

  const mutation = useMutation({
    mutationFn: async (data) => {
      const response = await axiosInstance.post("/reset-password", data);
      return response.data;
    },
    onSuccess: (data) => {
      toast.success(data.message);
      navigate("/login");
    },
    onError: (err) => {
      const message =
        err.response?.data?.message ||
        "Failed to reset password. Try again later.";
      toast.error(message);
    },
  });

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (formData.password !== formData.password_confirmation) {
      toast.error("Passwords do not match.");
      return;
    }

    mutation.mutate(formData);
  };

  return (
    <div className="authincation h-100 p-meddle">
      <div className="container h-100">
        <div className="row justify-content-center h-100 align-items-center">
          <div className="col-md-6">
            <div className="authincation-content">
              <div className="row no-gutters">
                <div className="col-xl-12">
                  <div className="auth-form">
                    <div className="text-center mb-3">
                      <Link to={"#"} className="logo">
                        <img
                          src={logo}
                          alt=""
                          className="w-100 mCS_img_loaded"
                        />
                      </Link>
                    </div>
                    <h4 className="text-center mb-4">Reset Password</h4>
                    <form onSubmit={handleSubmit}>
                      <div className="form-group mb-3">
                        <label>
                          <strong>OTP from your email</strong>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter your one-time PIN"
                          onChange={handleInputChange}
                          id="token"
                          required
                          value={formData.token}
                        />
                      </div>
                      <div className="form-group mb-3">
                        <label>
                          <strong>Email</strong>
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          placeholder="hello@example.com"
                          onChange={handleInputChange}
                          id="email"
                          required
                          value={formData.email}
                        />
                      </div>
                      <div className="form-group mb-3">
                        <label>
                          <strong>New Password</strong>
                        </label>
                        <PasswordInput
                          autoComplete="new-password"
                          placeholder="Enter new password"
                          onChange={handleInputChange}
                          id="password"
                          required
                          value={formData.password}
                        />
                      </div>
                      <div className="form-group mb-3">
                        <label>
                          <strong>Confirm Password</strong>
                        </label>
                        <PasswordInput
                          autoComplete="new-password"
                          placeholder="Confirm new password"
                          onChange={handleInputChange}
                          id="password_confirmation"
                          required
                          value={formData.password_confirmation}
                        />
                      </div>
                      <div className="text-center">
                        <button
                          type="submit"
                          className="btn btn-primary btn-block"
                          disabled={
                            !formData.token ||
                            !formData.email ||
                            !formData.password ||
                            !formData.password_confirmation ||
                            mutation.isLoading
                          }
                        >
                          {mutation.isLoading
                            ? "Resetting Password..."
                            : "Reset Password"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
